// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_fs-0";